import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { AccordionComponent } from './ui/accordion/accordion.component';
import { TableComponent } from './ui/table/table.component';

@NgModule({
  declarations: [
    AccordionComponent,
    TableComponent
  ],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    AccordionComponent,
    TableComponent
  ],
})
export class UiModule { } 